"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _excluded = ["title", "message", "Icon", "variant"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      // maxWidth: 345,
      display: 'flex',
      border: 'solid 1px',
      borderColor: theme.palette.error[500],
      width: '100%',
      maxWidth: 600,
      padding: theme.spacing(2),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.error[100],
      '&.variant-warning': {
        borderColor: theme.palette.warning[500],
        backgroundColor: theme.palette.warning[100]
      }
    },
    icon: {
      flexGrow: 0,
      width: 48,
      height: 48,
      marginRight: theme.spacing(2),
      color: theme.palette.getContrastText(theme.palette.error[800]),
      backgroundColor: theme.palette.error[800],
      '&.variant-warning': {
        color: theme.palette.getContrastText(theme.palette.warning[800]),
        backgroundColor: theme.palette.warning[800]
      }
    },
    typo: {
      flexGrow: 1,
      color: theme.palette.error[900],
      '&.variant-warning': {
        color: theme.palette.warning[900]
      }
    }
  };
});

var Alert = function Alert(_ref) {
  var title = _ref.title,
      message = _ref.message,
      Icon = _ref.Icon,
      variant = _ref.variant,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    className: (0, _classnames["default"])(classes.root, "variant-".concat(variant))
  }, other), /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    className: (0, _classnames["default"])(classes.icon, "variant-".concat(variant))
  }, /*#__PURE__*/_react["default"].createElement(Icon, null)), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: (0, _classnames["default"])(classes.typo, "variant-".concat(variant))
  }, title && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    style: {
      fontWeight: 'bold'
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, message)));
};

Alert.propTypes = {
  Icon: _propTypes["default"].node,
  message: _propTypes["default"].string,
  title: _propTypes["default"].string,
  variant: _propTypes["default"].string
};
Alert.defaultProps = {
  Icon: _Warning["default"],
  message: 'Toegang geblokkeerd',
  variant: 'error'
};
var _default = Alert;
exports["default"] = _default;